export const partners = {
  seo: {
    title: "Partnership - Bespire",
    description: "Join our partners and help creators achieve their success. Dedicated tools, visibility and premium support await you.",
    keywords: "partner program, creator platform, collaboration, technology partner, creator economy"
  },
  navigation: {
    benefits: "Benefits",
    requirements: "Requirements",
    process: "Process", 
    contact: "Contact",
    home: "Home"
  },
  hero: {
    badge: "Partner Program",
    title: "Join Bespire Partners",
    subtitle: "Support the creator economy and build the future with us",
    description: "Be part of the mission to make every creator successful. Our partners receive exclusive benefits and play a key role in platform development.",
    cta: "Apply as Partner"
  },
  benefits: {
    title: "Why become our partner?",
    subtitle: "Partnership with countless benefits awaits you",
    items: [
      {
        title: "Website visibility",
        description: "Partner names and logos appear on our homepage, increasing brand visibility.",
        icon: "Globe"
      },
      {
        title: "Partner badge usage",
        description: "Use the 'Bespire Partner' badge on your websites and marketing materials.",
        icon: "Shield"
      },
      {
        title: "Dedicated admin interface",
        description: "Easily manage multiple creators at once with the administration interface designed for partners.",
        icon: "Users"
      },
      {
        title: "Priority support",
        description: "Partners enjoy priority in customer service and technical support.",
        icon: "Heart"
      },
      {
        title: "Early access to new features",
        description: "Be the first to try new features and services before public release.",
        icon: "Zap"
      },
      {
        title: "Joint marketing opportunities",
        description: "We work together on joint marketing campaigns and event appearances.",
        icon: "TrendingUp"
      },
      {
        title: "Networking opportunities",
        description: "Connect with other partners and creators at our exclusive events and community.",
        icon: "MapPin"
      },
      {
        title: "Technology integration",
        description: "API access and technology integration possibilities with your own systems.",
        icon: "Laptop"
      },
      {
        title: "Service fee charging",
        description: "Charge creators for building and customizing their websites using our platform.",
        icon: "DollarSign"
      }
    ]
  },
  partnerValue: {
    title: "What do we provide to creators as partners?",
    subtitle: "Through our partners, creators get exclusive additional services",
    description: "Our partners not only offer their own expertise and services, but also provide access to Bespire's most advanced technologies and exclusive features.",
    items: [
      {
        title: "Most advanced AI technology",
        description: "Our partners can use the latest AI models for personalized content generation and automated business processes.",
        icon: "Zap"
      },
      {
        title: "Exclusive platform features",
        description: "Early access to new developments and beta features that the general public cannot use yet.",
        icon: "Users"
      },
      {
        title: "Featured visibility opportunities",
        description: "Partner creators receive priority on the platform's promotional surfaces and appear in highlighted positions.",
        icon: "Shield"
      },
      {
        title: "Premium templates and tools",
        description: "Access to exclusive design templates, advanced analytics tools and premium integrations.",
        icon: "Monitor"
      },
      {
        title: "Dedicated technical support",
        description: "24/7 technical support and personal account manager for partner project success.",
        icon: "Heart"
      },
      {
        title: "API and custom integrations",
        description: "Full API access and custom integration development according to partner specific needs.",
        icon: "Laptop"
      }
    ]
  },
  requirements: {
    title: "Who can be our partners?",
    subtitle: "We're looking for companies and service providers who share our values",
    items: [
      {
        title: "Technology companies",
        description: "Software, application and platform developers who provide complementary services.",
        icon: "Monitor"
      },
      {
        title: "Marketing agencies",
        description: "Digital marketing and brand building experts who help creators grow.",
        icon: "TrendingUp"
      },
      {
        title: "Educational institutions",
        description: "Universities, colleges and training centers that offer creator courses.",
        icon: "GraduationCap"
      },
      {
        title: "Financial service providers",
        description: "Banks, fintech companies and financial advisors supporting creator businesses.",
        icon: "DollarSign"
      }
    ]
  },
  process: {
    title: "How does the partnership work?",
    subtitle: "Simple steps to successful collaboration",
    steps: [
      {
        title: "Application",
        description: "Fill out the application form and present your company and services.",
        icon: "FileText"
      },
      {
        title: "Evaluation",
        description: "Our team reviews your application and provides feedback on the results within 48 hours.",
        icon: "CheckCircle"
      },
      {
        title: "Contract",
        description: "If you're suitable, we sign the partnership agreement and start collaboration.",
        icon: "FileCheck"
      },
      {
        title: "Onboarding",
        description: "We introduce you to the system, set up access and start working together.",
        icon: "Users"
      }
    ]
  },
  cta: {
    title: "Ready for partnership?",
    subtitle: "Join us and let's shape the future of the creator economy together!",
    button: "Apply Now",
    note: "No commission, no hidden costs – just mutually beneficial collaboration."
  },
  contact: {
    title: "Have questions?",
    subtitle: "Get in touch with us!",
    email: "partners@bespire.com",
    responseTimeLabel: "Response time",
    responseTime: "We respond within 24 hours"
  },
  footer: {
    support: "Support",
    getStarted: "Get Started",
    contact: "Contact",
    privacy: "Privacy",
    privacyComingSoon: "Privacy policy coming soon!"
  }
};